import '@progress/kendo-ui/js/kendo.grid';

//Module localization 
import localeEn from '../../../../../locales/en'
import localeAr from '../../../../../locales/ar'

import ReportViewer from '@/app/shared/components/report-viewer/report-viewer.vue';


export default {
    name: "cheques-report",
    data() {
        return {
            reportRequest: {
                ReportId: 100072,
                ReportRequestParameters: []
            }
        }
    },
    components: {
        ReportViewer
    },
    i18n: {
        messages: {
            en: {
                ...localeEn
            },
            ar: {
                ...localeAr
            }
        },
    },
};